import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../config/authaxios";

const initialState = { status: null, data: [], loading: false, message: '', currentRequestId: undefined };



export const getCategoryAction = createAsyncThunk("get-category", async (data = null, { rejectWithValue }) => {
    try {
        const publisherId = data?.publisherId;
        const isDeleted = data?.isDeleted ?? false;
        const response = await axios.get(
            publisherId
                ? `/admin/publisher/categories/${publisherId}/${isDeleted}`
                : `/admin/product/categories`
        );
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data)
    }
});

const getCategorySlice = createSlice({
    name: "get-category",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(getCategoryAction.pending, (state, action) => {
            state.loading = true;
            // Track the latest request so stale, out-of-order responses
            // (e.g. an older global fetch resolving after a newer
            // publisher-filtered fetch) don't overwrite fresher data.
            state.currentRequestId = action.meta.requestId;
        });
        builder.addCase(getCategoryAction.fulfilled, (state, action) => {
            if (state.currentRequestId !== action.meta.requestId) return;
            state.loading = false;
            state.message = action.payload?.message;
            state.status = action.payload.status_code;
            if(state.status==401){
                localStorage.clear()
              }
            state.data = action.payload?.response;
            state.currentRequestId = undefined;
        });
        builder.addCase(getCategoryAction.rejected, (state, action) => {
            if (state.currentRequestId !== action.meta.requestId) return;
            state.loading = false;
            state.message = action.payload?.message;
            state.status = action.payload.status_code;
            state.error = action.error.message;
            state.currentRequestId = undefined;
        });
    },
});




export const getCategoryReducer = getCategorySlice.reducer;

